import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { ArrowChevronRightMiniIcon } from '@calendly/ui/components/icons';
import { Link } from '@calendly/ui/components/link';
import classNames from 'classnames';
import { forwardRef } from 'react';
const floatingContainerCss = "fn5jzbk";
const FloatingContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(floatingContainerCss, props.className)} />;
});
const roundedButtonCss = "ribw6oe";
const RoundedButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(roundedButtonCss, props.className)} />);

// i18n-tasks-use t("publisher.event_types.share_modal.calendar.no_times_month.#{month}")
export const NoDatesAvailable = ({
  onClick,
  month
}) => <FloatingContainer>
    <RoundedButton onClick={onClick}>
      <p>
        {I18n.t(month.toLowerCase(), {
        scope: 'publisher.event_types.share_modal.calendar.no_times_month'
      })}
      </p>
      <Link underline={false} as="div">
        {I18n.t('publisher.event_types.share_modal.calendar.view_next_month')}
        <ArrowChevronRightMiniIcon />
      </Link>
    </RoundedButton>
  </FloatingContainer>;

require("./no_dates_available.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./no_dates_available.js");